<template>
  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="row page-titles">
      <div class="col-md-5 col-8 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/home">Home</router-link>
          </li>
          <li class="breadcrumb-item ">
            <a @click.prevent="$router.go(-1)">ケアプラン一覧</a>
          </li>
          <li class="breadcrumb-item active">ケアプラン</li>
        </ol>
      </div>
    </div>
    <div class="row" v-show="errors.any()">
      <div class="col-md-12">
        <div class="alert alert-warning">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          <ul>
            <li v-for="(error,index) in errors.collect()" :key="index">
              {{error[0]}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card edit-card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label class="control-label" v-if="office">事業所：{{office.display_name}}</label>
              </div>
              <div class="col-md-3">
                <label class="control-label" v-if="user">利用者：{{user.display_name}}</label>
              </div>
              <!--/span-->
            </div>
            <hr>
            <div class="form-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-5">
                      <label class="control-label">日時</label>
                      <div class="input-group">
                        <div style="width: 170px" class="form-group" :class="{'has-danger': errors.has('start_day') }">
                          <input class="form-control"
                                 type="date"
                                 v-model="inputs.start_day">
                          <input type="hidden" name="start_day"
                                 v-model="inputs.start_day"
                                 v-validate="'required'"
                                 data-vv-as="日付"
                                 data-vv-validate-on="none">
                        </div>
                        <div style="width: 110px" class="form-group" :class="{'has-danger': errors.has('start_hhmm') }">
                          <input class="form-control"
                                 type="time"
                                 name="start_hhmm"
                                 v-validate="'required'"
                                 v-model="inputs.start_hhmm"
                                 data-vv-as="開始時刻"
                                 data-vv-validate-on="none">
                        </div>
                        <div style="line-height: 38px;">〜</div>
                        <div style="width: 110px" class="form-group" :class="{'has-danger': errors.has('end_hhmm') }">
                          <input class="form-control"
                                 type="time"
                                 name="end_hhmm"
                                 v-validate="'required'"
                                 v-model="inputs.end_hhmm"
                                 data-vv-as="終了時刻"
                                 data-vv-validate-on="none">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-7">
                      <label class="control-label">サービスコード</label>
                      <div class="input-group">
                        <div style="width: 200px" class="form-group"
                             :class="{'has-danger': errors.has('service_type') }">
                          <select-service-type
                            name="service_type"
                            v-model="inputs.service_type_id"
                            v-validate="'required'"
                            data-vv-as="サービス種別"
                            data-vv-validate-on="none"/>
                        </div>
                        <select-service-code :service-type-id="inputs.service_type_id"
                                             :target-date="inputs.start_day"
                                             v-model="inputs.service_code_id"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="m-l-10 input-group">
                        <input id="ownExpenseFlag" type="checkbox" v-model="inputs.ownExpenseFlag"/>
                        <label for="ownExpenseFlag" class="font-14">自費サービス</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="m-l-10">
                        <label class="control-label p-t-10">行き先</label>
                        <div class="input-group">
                          <input type="text" class="form-control" maxlength="60"
                                 v-model="inputs.destination"
                                 v-validate="'max:60'"
                                 name="service.destination"
                                 :class="{'has-danger': errors.has('service.destination') }"
                                 data-vv-as="行き先"
                                 data-vv-validate-on="none"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--/span-->
              </div>

              <div class="row">
                <div class="col-md-9">
                  <template>
                    <ul class="nav nav-tabs customtab" role="tablist">
                      <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#home2" role="tab"><span
                        class="hidden-sm-up"><i class="ti-home"></i></span> <span class="hidden-xs-down">詳細設定</span></a>
                      </li>
                      <li class="nav-item" v-if="false"><a class="nav-link" data-toggle="tab" href="#profile2"
                                                           role="tab"><span
                        class="hidden-sm-up"><i class="ti-user"></i></span> <span class="hidden-xs-down">加算</span></a>
                      </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content">
                      <div class="tab-pane p-3 active" id="home2" role="tabpanel">
                        <div class="row" v-show="false">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">時間帯</label>
                              <select-code :code-group="Code.PERIOD_OF_DAY" v-model="inputs.period_of_day_cd"/>
                            </div>
                          </div>
                          <!--/span-->
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">特定加算</label>
                              <select-code :code-group="Code.PERIOD_OF_DAY" v-model="inputs.period_of_day_cd"/>
                            </div>
                          </div>
                          <!--/span-->
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">その他</label>
                              <div>
                                <input type="checkbox" id="a" class="filled-in" checked/>
                                <label for="a">初回訪問</label>
                                <span class="pr-2"></span>
                                <input type="checkbox" id="b" class="filled-in" checked/>
                                <label for="b">責任者減算</label>
                              </div>
                            </div>
                          </div>
                          <!--/span-->
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <select-care-item :service-type-id="inputs.service_type_id" v-model="inputs.service_items"/>
                          </div>
                          <!--/span-->
                        </div>
                        <div class="row pt-3">
                          <div class="col-md-12">
                            <div class="form-group" :class="{'has-danger': errors.has('instruction') }">
                              <label class="control-label">指示事項</label>
                              <textarea class="form-control" rows="5" v-model="inputs.instruction"></textarea>
                            </div>
                          </div>
                          <!--/span-->
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="col-md-3">
                  <template>
                    <ul class="nav nav-tabs customtab" role="tablist">
                      <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#home3" role="tab"><span
                        class="hidden-sm-up"><i class="ti-home"></i></span> <span class="hidden-xs-down">担当者</span></a>
                      </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content">
                      <div class="tab-pane p-3 active" id="home3" role="tabpanel">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <select-staff :office-id="this.office.id" v-if="office" v-model="inputs.staff1"/>
                              <select-staff :office-id="this.office.id" v-if="office" v-model="inputs.staff2"/>
                              <select-staff :office-id="this.office.id" v-if="office" v-model="inputs.staff3"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <hr>
            <div class="form-actions actions">
              <div class="row">
                <div class="col-md-12 text-right">
                  <a href="#" @click="back">キャンセル</a>
                  <template v-if="id">
                    <span class="mx-2"></span>
                    <button type="submit" class="action-button btn btn-danger btn-rounded"
                            :disabled="(plan && plan.reports && plan.reports.length > 0)"
                            @click.prevent="destroy">
                      削除する
                    </button>
                  </template>
                  <span class="mx-2"></span>
                  <button type="submit" class="action-button btn btn-success btn-rounded" @click.prevent="register">
                    登録する
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-modal v-model="isProcessing" message="更新中..."/>
    <v-dialog/>
  </div>
</template>

<script>
import _ from 'underscore'
import co from 'co'
import dayjs from 'dayjs'
import { mapActions } from 'vuex'
import api from '../../libs/Api'
import utils from '../../libs/Utils'
import SelectStaff from '../../components/SelectStaff'
import SelectCareItem from '../../components/SelectCareItems'
import SelectCode from '../../components/SelectCode'
import SelectServiceType from '../../components/SelectServiceType'
import SelectServiceCode from '../../components/SelectServiceCode'
import LoadingModal from '../../components/LoadingModal'

export default {
  name: 'PlanEdit',
  components: {
    SelectStaff,
    SelectCode,
    SelectCareItem,
    SelectServiceType,
    SelectServiceCode,
    LoadingModal
  },
  data () {
    return {
      id: null,
      user: null,
      office: null,
      isLoading: false,
      plan: null,
      inputs: {
        start_day: null,
        start_hhmm: null,
        end_day: null,
        end_hhmm: null,
        service_type_id: null,
        service_code_id: null,
        instruction: null,
        service_items: [],
        staff1: null,
        staff2: null,
        staff3: null,
        ownExpenseFlag: false,
        destination: null
      }
    }
  },
  created: function () {
    this.exec(_this => {
      _this.id = _this.$route.params.id
      _this.load()
    })
  },
  methods: {
    load () {
      this.exec(_this => {
        if (_this.id) {
          _this.isLoading = true
          return co(function * () {
            const res = yield api.getPlan(_this.id)
            return Promise.resolve(res)
          }).then(plan => {
            _this.user = plan.user
            _this.office = plan.office
            _this.inputs = _convertPlan2Inputs(plan)
            _this.plan = plan
          }).finally(() => {
            _this.isLoading = false
          })
        } else {
          //
          // 新規登録時
          //
          _this.isLoading = true
          _this.inputs.start_day = utils.formatDay(_this.$route.query.day)
          const officeId = _this.$route.query.office_id
          const userId = _this.$route.query.user_id

          return co(function * () {
            const user = yield api.findUser(userId)
            const office = yield _this.findOffice(officeId)
            return Promise.resolve({
              user: user,
              office: office
            })
          }).then(({ user, office }) => {
            _this.user = user
            _this.office = office
          }).finally(() => {
            _this.isLoading = false
          })
        }
      })
    },
    destroy () {
      this.$modal.show('dialog', {
        title: '確認',
        text: `削除してもよろしいですか？`,
        clickToClose: true,
        buttons: [
          {
            title: 'キャンセル'
          },
          {
            title: 'はい',
            clickToClose: true,
            handler: () => {
              this.exec(_this => {
                return co(function * () {
                  yield _this.destroyPlan(_this.id)
                  return Promise.resolve(true)
                }).then(result => {
                  if (!result) return
                  _this.$toasted.success('削除しました。', {
                    position: 'top-center',
                    duration: 2000
                  })
                  _this.$router.go(-1)
                }).finally(() => {
                  _this.isProcessing = false
                })
              })
            }
          }
        ]
      })
    },
    register () {
      this.exec(_this => {
        return co(function * () {
          _this.$validator.errors.clear()
          if (!(yield _this.$validator.validateAll())) {
            return Promise.resolve(false)
          }
          const plan = _convertInputs2Plan(_this.inputs)
          if (_this.id) {
            plan.id = _this.id
          }
          plan.user_id = _this.user.id
          plan.office_id = _this.office.id
          _this.isProcessing = true
          yield _this.savePlan(plan)
          return Promise.resolve(true)
        }).then(result => {
          if (!result) return
          _this.$router.go(-1)
        }).finally(() => {
          _this.isProcessing = false
        })
      })
    },
    ...mapActions('office', ['findOffice']),
    ...mapActions('careplan', ['savePlan', 'destroyPlan'])
  }
}

/**
 * 入力データをPlanのフォーマットに変換
 * @param plan
 * @returns array
 * @private
 */
function _convertPlan2Inputs (plan) {
  let inputs = {
    start_day: utils.formatDay(plan.service.start_day),
    start_hhmm: utils.formatHHMM(plan.service.start_hhmm),
    end_day: utils.formatDay(plan.service.end_day),
    end_hhmm: utils.formatHHMM(plan.service.end_hhmm),
    service_type_id: plan.service.service_type_id,
    service_code_id: plan.service.service_code_id,
    ownExpenseFlag: plan.service.own_expense_flag,
    destination: plan.service.destination,
    instruction: plan.instruction,
    service_items: _.map(plan.service.service_items, serviceItem => {
      return serviceItem.care_item_id
    }),
    staff1: null,
    staff2: null,
    staff3: null
  }
  if (plan.staff.length > 0) {
    inputs.staff1 = plan.staff[0].id
  }
  if (plan.staff.length > 1) {
    inputs.staff2 = plan.staff[1].id
  }
  if (plan.staff.length > 2) {
    inputs.staff3 = plan.staff[2].id
  }
  return inputs
}

/**
 * Planフォーマットを入力データに変換
 * @param inputs
 * @returns array
 * @private
 */
function _convertInputs2Plan (inputs) {
  const startDay = inputs.start_day.replace(/-/g, '')
  let endDay = startDay
  const startHhmm = inputs.start_hhmm.replace(':', '')
  const endHhmm = inputs.end_hhmm.replace(':', '')

  if (Number(startHhmm) > Number(endHhmm)) {
    endDay = dayjs(startDay).add(1, 'days').format('YYYYMMDD')
  }

  const staff = []
  const inputStaffs = [inputs.staff1, inputs.staff2, inputs.staff3]
  inputStaffs.forEach(inputStaff => {
    if (inputStaff) {
      staff.push({ staff_id: inputStaff })
    }
  })

  return {
    instruction: inputs.instruction,
    staff: staff,
    service: {
      service_type_id: inputs.service_type_id,
      service_code_id: inputs.service_code_id,
      start_day: startDay,
      start_hhmm: startHhmm,
      end_day: endDay,
      end_hhmm: endHhmm,
      own_expense_flag: inputs.ownExpenseFlag,
      destination: inputs.destination,
      service_items: _.map(inputs.service_items, serviceItem => {
        return { care_item_id: serviceItem }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.form-body {
  height: 70vh;
  overflow: scroll;
}

.actions {
  background-color: white;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: -20px;
  padding: 5px;
}

</style>
